module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tagMappingActionTypeSelect.AddNewTagAction.title":"Add Tag","tagMappingActionTypeSelect.CopyValue.title":"Copy Value","tagMappingActionTypeSelect.RemoveTag.title":"Remove Tag","tagMappingActionTypeSelect.Markup.title":"Markup Cost"}}')
  delete Component.options._Ctor
}
